var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"p-custom"},[_c('div',{staticClass:"p-block"},[_c('div',{staticClass:"p-custom-list"},[_c('List',{attrs:{"needLoadMore":false,"listParamsPos":_vm.listParamsPos}})],1),_c('Roll')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }